export default __webpack_public_path__ + "images/0x78ab77f7d590fb101aa18affc238cbfea31ead5b.png";